// Shared by the reader, editor, XLSX importer and API. Keep this module browser safe.
const HEADERS = [
  "key",
  "optionText",
  "leadsTo",
  "desc",
  "requirements",
  "blocker",
  "rewards",
  "removes",
];
const blankOption = (key = 1) => ({
  key,
  optionText: "",
  leadsTo: 0,
  desc: "",
  requirements: "",
  blocker: "",
  rewards: "",
  removes: "",
});
const splitTags = (value) =>
  String(value || "")
    .split(/[|,]/)
    .map((tag) => tag.trim())
    .filter(Boolean);

function normalizeRows(input) {
  if (!Array.isArray(input) || !input.length)
    throw new Error("Add at least one choice to your story.");
  if (input.length > 5000)
    throw new Error("Stories may contain at most 5,000 choices.");
  return input.map((row, index) => {
    if (!row || typeof row !== "object")
      throw new Error(`Choice ${index + 1} is invalid.`);
    const result = {};
    HEADERS.forEach((field) => {
      if (field === "key" || field === "leadsTo") {
        const value = Number(row[field]);
        if (
          row[field] === "" ||
          row[field] == null ||
          !Number.isSafeInteger(value) ||
          value < (field === "key" ? 1 : 0)
        ) {
          throw new Error(
            `Choice ${index + 1}: ${field} must be ${field === "key" ? "a positive whole number" : "a whole number (0 ends the story)"}.`,
          );
        }
        result[field] = value;
      } else {
        result[field] = String(row[field] ?? "");
        if (result[field].length > 30000)
          throw new Error(`Choice ${index + 1}: ${field} is too long.`);
      }
    });
    if (!result.optionText.trim())
      throw new Error(`Choice ${index + 1} needs button text.`);
    return result;
  });
}

function validateStory(input) {
  const rows = normalizeRows(input);
  const keys = new Set(rows.map((row) => row.key));
  if (!keys.has(1))
    throw new Error("Your story needs a starting scene with key 1.");
  rows.forEach((row, index) => {
    if (row.leadsTo !== 0 && !keys.has(row.leadsTo)) {
      throw new Error(
        `Choice ${index + 1} leads to missing scene ${row.leadsTo}. Add that scene or use 0 for an ending.`,
      );
    }
  });
  return rows;
}

function availableOptions(rows, key, traits) {
  return rows.filter(
    (row) =>
      Number(row.key) === Number(key) &&
      (!splitTags(row.requirements).length ||
        splitTags(row.requirements).some((tag) => traits.includes(tag))) &&
      !splitTags(row.blocker).some((tag) => traits.includes(tag)),
  );
}

function chooseOption(option, traits) {
  const rewards = splitTags(option.rewards);
  const restart = rewards.some((tag) => tag.toLowerCase() === "restart");
  const removes = splitTags(option.removes);
  return {
    node: Number(option.leadsTo),
    text: String(option.desc || ""),
    traits: restart
      ? []
      : [...new Set([...traits, ...rewards])].filter(
          (tag) => !removes.includes(tag),
        ),
  };
}

module.exports = {
  HEADERS,
  blankOption,
  splitTags,
  normalizeRows,
  validateStory,
  availableOptions,
  chooseOption,
};
